<script setup lang="ts">
  import { useStoryblokStore } from '@/stores/StoryBlok.store'

  const storyblokStore = useStoryblokStore()
  const route = useRoute()
  const { locale } = useI18n()

  const STORYBLOK_EDITOR_QUERY_KEY = 'sb'
  const isEditorLinkEnabled = computed(() => STORYBLOK_EDITOR_QUERY_KEY in route.query)

  const {
    public: { storyblokSpaceId }
  } = useRuntimeConfig()

  const storyblokEditorUrl = computed(() => {
    if (!isEditorLinkEnabled.value) return null
    if (!storyblokStore.data?.id) return null
    if (!storyblokSpaceId) return null

    const branchId = 0
    const releaseId = 0
    const spaceId = storyblokSpaceId
    const storyId = storyblokStore.data.id

    return `https://app.storyblok.com/#/me/spaces/${spaceId}/stories/${branchId}/${releaseId}/${storyId}?lang=${locale.value}`
  })
</script>

<template>
  <div
    v-if="storyblokEditorUrl"
    class="fixed bottom-3 right-3 z-50"
  >
    <NuxtLink
      :to="storyblokEditorUrl"
      external
      target="_blank"
      class="no-underline"
    >
      <UiButton
        title="Edit"
        variant="primary"
        class="font-medium"
        icon="common/edit-note"
      />
    </NuxtLink>
  </div>
</template>
